import { Global, css } from "@emotion/react"

type RadioButtonProps = {
  id?: string
  checked: boolean
  disabled: boolean
  value: string
  children: React.ReactNode
  onChange: () => void
}

export function RadioButton({
  id,
  checked,
  value,
  children,
  onChange,
  disabled,
}: RadioButtonProps) {
  function handleChange() {
    onChange()
  }

  const uniqueInputId = id ? id : value

  return (
    <>
      <Global
        styles={css`
          .radio:checked + .radio-label:before {
            background-color: var(--color-brand);
          }
        `}
      />
      <input
        type="radio"
        name={uniqueInputId}
        id={uniqueInputId}
        className="radio"
        checked={checked}
        disabled={disabled}
        onChange={handleChange}
        value={value}
      />
      <label
        className="radio-label"
        css={{ cursor: "pointer" }}
        htmlFor={uniqueInputId}
      >
        {children}
      </label>
    </>
  )
}
